export default __webpack_public_path__ + "static/media/caveman.988d1b30.png";